// AI Generated Test
import { Component, OnInit, OnDestroy } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { PagesTabsHelper } from '@client/app/blocks/helpers/pages-tabs.helper';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { CheckForDuplicatesService } from '@client/app/core/services/check-for-duplicates/check-for-duplicates.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { LabelService } from '@monsido/services/label-service/label.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-pages',
    standalone: false,
    template: `
        <page-header
                [icon]="['POLICIES', 'PAGES'] | monIcons"
            [header]="'Issues by Page' | translate"
                [subHeader]="getSubHeader()">
        </page-header>

        <mon-tabs [options]="tabs"
                  [(status)]="activeTab"
                  (onSearch)="onSearch($event)"
                  (onStatus)="onStatus($event)"
                  [search]="search"
                  [showSearch]="true"
                  [showFiltersBtn]="showFilters"
                  [(isFiltersOpen)]="isFiltersOpen">
            <csv-export-button category="policy_pages"></csv-export-button>
        </mon-tabs>

        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container
                        [progress]="progress"
                        [collection]="pages"
                        (onPageChange)="onPageChange($event)"
                        [noResultMessage]="'Congratulations no violations were found' | translate"
                        (onPerPageChange)="onPageSizeChange($event)"
                        class="pages-table-wrapper">
                    <table-container-top>
                        <div class="mb-4 merge-r-36 merge-l-36 merge-t-10" *ngIf="isFiltersOpen">
                            <table-filters [(open)]="isFiltersOpen"
                                           [(ngModel)]="filters"
                                           name="filters"
                                           [filters]="availableFilters"
                                           (onChanges)="onFiltersChanges($event)">
                            </table-filters>
                        </div>
                    </table-container-top>
                    <table class="table table-hover table-fixed policy-violations-table table-with-labels">
                        <thead>
                        <tr>
                            <th monTableSort
                                [monSortBy]="'title'"
                                [monSortDirection]="currentSort.direction"
                                [monCurrentlySortedBy]="currentSort.by"
                                (monOnSorted)="onMonTableSort($event)"
                                [monThTitle]="'Title and URL' | translate">
                            </th>
                            <th class="col-sm-4 col-md-4 col-lg-3 text-right">
                                {{ 'Unwanted' | translate }}
                            </th>
                            <th class="col-sm-4 col-md-4 col-lg-3 text-right">
                                {{ 'Required' | translate }}
                            </th>
                            <th class="col-sm-4 col-md-4 col-lg-3 text-right">
                                {{ 'Matches' | translate }}
                            </th>
                            <th *ngIf="!(activeTab === 'pdf' || activeTab === 'document')"
                                monTableSort
                                [monSortBy]="'priority_score'"
                                [monSortDirection]="currentSort.direction"
                                [monCurrentlySortedBy]="currentSort.by"
                                (monOnSorted)="onMonTableSort($event)"
                                class="col-sm-4 col-md-4 col-lg-4 text-right"
                                [monThTitle]="'Priority' | translate">
                            </th>
                            <th *ngIf="!(activeTab === 'pdf' || activeTab === 'document') && viewsColumIsAvailable"
                                monTableSort
                                [monSortBy]="'hits'"
                                [monSortDirection]="currentSort.direction"
                                [monCurrentlySortedBy]="currentSort.by"
                                (monOnSorted)="onMonTableSort($event)"
                                class="col-sm-3 col-md-4 col-lg-4 text-right">
                                <span>
                                    {{ 'Views' | translate }}
                                </span>
                                <span *ngIf="hasAccessToStats"
                                      class="ml-1"
                                      [ngClass]="['POLICIES', 'QUESTION_CIRCLE'] | monIcons"
                                      aria-hidden="true"
                                      [ngbTooltip]="'Total page views over the last 30 days' | translate"
                                      [triggers]="'focus hover'">
                                </span>
                                <span *ngIf="!hasAccessToStats"
                                      class="ml-1"
                                      [ngClass]="['POLICIES', 'EXCLAMATION'] | monIcons"
                                      aria-hidden="true"
                                      [ngbTooltip]="'Statistics not activated. Page Views not available.' | translate"
                                      [triggers]="'focus hover'">
                                </span>
                            </th>
                            <th class="col-sm-8 col-md-8 col-lg-4 text-right">&nbsp;</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let page of pages">
                            <td>
                                <div class="text-ellipsis">
                                    <mon-url-title
                                            *ngIf="!pageDetailsIsAvailable"
                                            [title]="page.title"
                                            [url]="page.url"
                                            [active]="false">
                                    </mon-url-title>
                                    <url-title-page-details
                                            *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                            [target]="'page-details-section-policies'"
                                            (onClose)="onPageDetailsClose()"
                                            [title]="page.title"
                                            [url]="page.url"
                                            [page]="page"
                                            [active]="false">
                                    </url-title-page-details>
                                    <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                [document]="page"
                                                                [title]="page.title"
                                                                [url]="page.url"
                                                                [active]="true"
                                                                [target]="'policies'"
                                                                [subTarget]="policy">
                                    </url-title-document-details>
                                </div>
                                <label-table *ngIf="showLabels"
                                                 [assignedLabels]="page.labels"
                                                 [existingLabels]="labels"
                                                 (getLabels)="getLabels()"
                                                 (onUpdateLabel)="updateLabelsPage(page)" />
                            </td>
                            <td class="inner-l-r-none text-v-middle text-right">
                                <icon-button
                                        [monAriaLabel]="('Unwanted count ' | translate) + ' ' + page.policy_violation_count"
                                        faIcon="fas fa-ban"
                                        [number]="page.policy_violation_count"
                                        positive="text-danger"
                                        negative="negative"
                                        neutral="text-neutral-misspelling"
                                        [monAriaIconText]="'Violation' | translate"
                                        [changeTextColor]="false">
                                </icon-button>
                            </td>
                            <td class="inner-l-r-none text-v-middle text-right">
                                <icon-button
                                        [monAriaLabel]="('Required count ' | translate) + ' ' + page.policy_required_count"
                                        faIcon="fas fa-exclamation-triangle"
                                        [number]="page.policy_required_count"
                                        positive="text-orange"
                                        negative="negative"
                                        neutral="text-neutral-misspelling"
                                        [monAriaIconText]="'Required' | translate"
                                        [changeTextColor]="false">
                                </icon-button>
                            </td>
                            <td class="inner-l-r-none text-v-middle text-right">
                                <icon-button
                                        [monAriaLabel]="('Matches count ' | translate) + ' ' + page.policy_search_count"
                                        faIcon="fas fa-search"
                                        [number]="page.policy_search_count"
                                        positive="text-info"
                                        neutral="text-neutral-misspelling"
                                        [monAriaIconText]="'Search' | translate"
                                        [changeTextColor]="false">
                                </icon-button>
                            </td>
                            <td *ngIf="!(activeTab === 'pdf' || activeTab === 'document')" class="text-v-middle text-right">
                                <mon-priority class="vcenter" [priority]="page.priority_score_as_text"></mon-priority>
                            </td>
                            <td *ngIf="viewsColumIsAvailable && !(activeTab === 'pdf' || activeTab === 'document')" class="text-v-middle">
                                <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                            </td>
                            <td class="d-flex align-items-center justify-content-end flex-wrap">
                                <table-page-details
                                        *ngIf="page.type === 'html'"
                                        [ngbTooltip]="'Open page details' | translate"
                                        [triggers]="'focus hover'"
                                        [page]="page"
                                        [target]="'page-details-section-policies'">
                                </table-page-details>
                                <table-document-details
                                        *ngIf="page.type !== 'html'"
                                        [ngbTooltip]="'Open document details' | translate"
                                        [triggers]="'focus hover'"
                                        target="policies"
                                        [subTarget]="policy"
                                        [document]="page"
                                        (callBack)="onPageDetailsClose()">
                                </table-document-details>
                                <mon-extension-visual-link-button [page]="page" [type]="'pol'" class="ml-1"></mon-extension-visual-link-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class PagesPolicyPagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    hasAccessToStats: any;
    eventId: any;
    viewsColumIsAvailable: any;
    pageDetailsIsAvailable: any;
    pages: any = [];
    tabs: any = [];
    selectedPolicyPriorities: any = [];
    policy: any;
    progress: any;

    constructor (
        private policyRepoService: PolicyRepoService,
        private pagesTabsHelper: PagesTabsHelper,
        private translateService: TranslateService,
        private baseEntityService: BaseEntityService,
        private checkForDuplicatesService: CheckForDuplicatesService,
        private activeFeatureService: ActiveFeatureService,
        private labelService: LabelService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.hasAccessToStats = this.activeFeatureService.isFeatureActive('statistics');
        this.eventId = this.monEventsService.addListener(
            'PAGE_UPDATED_EVENT' as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.search = '';
        this.tabs = [];
        this.activeTab = this.pagesTabsHelper.getActiveTab() || 'all';
        this.currentSort = { by: 'priority_score', direction: 'desc' };
        this.selectedPolicyPriorities = [];
        this.filters.priorities = [];

        this.getPage();
        this.setupTabs();
        this.setupPolicyPriorities();
        this.getLabels();
    }

    ngOnDestroy (): void {
        this.monEventsService.remove(this.eventId);
    }

    setupTabs (): void {
        this.tabs = this.pagesTabsHelper.getTabs();
    }

    setupPolicyPriorities (): void {
        this.availableFilters.priorities = [
            {
                name: this.translateService.getString('Unwanted'),
                value: 'unwanted',
            },
            {
                name: this.translateService.getString('Required'),
                value: 'required',
            },
            {
                name: this.translateService.getString('Matches'),
                value: 'matches',
            },
        ];
    }

    override getPage (): void {
        this.pages = [];
        this.progress = 0;

        let params: any = {
            page: this.page,
            page_size: this.pageSize,

            search: this.search || null,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.activeTab && this.activeTab !== 'all') {
            params['types[]'] = [this.activeTab];
        }

        params = this.updateParamsWithFilters(params);
        params = this.updateParamsWithPolicyFilters(params);

        this.progress = this.policyRepoService.domainGetPages(params).then((pages: any) => {
            this.checkForDuplicatesService.checkForDuplicatePages(pages);
            this.pages = pages;
        }, () => {});
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        this.updatePolicyFilters(changes);
        this.getPage();
    }

    updateParamsWithPolicyFilters (params: any): any {
        if (this.selectedPolicyPriorities && this.selectedPolicyPriorities.length > 0) {
            if (this.selectedPolicyPriorities.indexOf('unwanted') > -1) {
                params.policy_violations = true;
            }
            if (this.selectedPolicyPriorities.indexOf('required') > -1) {
                params.policy_required = true;
            }
            if (this.selectedPolicyPriorities.indexOf('matches') > -1) {
                params.policy_searches = true;
            }
        }

        return params;
    }

    updatePolicyFilters (changes: any): void {
        if (changes.changes) {
            changes = changes.changes;
        }

        if (changes.priorities) {
            this.selectedPolicyPriorities = changes.priorities.map((priority: any) => {
                return priority.value;
            });
        } else {
            this.selectedPolicyPriorities = [];
        }
    }

    createOrUpdateLabel (label: any): void {
        this.labelService.createOrUpdateLabel(label);
    }

    updateLabelsPage (page: any): void {
        this.updateLabels(page);
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    getSubHeader (): string {
        const foundText = this.translateService.getString('Found');
        const pageText = this.translateService.getPlural(
            this.pages.total || 0,
            'page',
            'pages',
            {},
            this.pages.total || 0,
        );
        return `${foundText} ${this.pages.total || 0} ${pageText}`;
    }
}
